module.exports = __webpack_public_path__ + "media/images/productos-65d5a681f5057127007575b993a8e50b.jpg";